import { useQuery } from "@tanstack/react-query"
import { getProductsBySubcategory } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductsBySubcategory(subCategory: string | null) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["products-by-subcategory", subCategory],
    queryFn: () => getProductsBySubcategory(subCategory!, accessToken ?? undefined),
    enabled: !!subCategory,
  })
}